import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const validateSerialNumberAction = getApiActionCreator(actionTypes.VALIDATE_SERIAL_NUMBER_SETTINGS);

export const validateSerialNumber = (oldSerialNumber, newSerialNumber, suffix, isMultiModuleDrive) => {
    return {
        type: actionTypes.VALIDATE_SERIAL_NUMBER,
        payload: {
            oldSerialNumber,
            newSerialNumber,
            suffix,
            isMultiModuleDrive
        }
    };
};

export const assignSerialNumberAction = getApiActionCreator(actionTypes.ASSIGN_SERIAL_NUMBER_SETTINGS);

export const assignSerialNumber = (requestBody) => {
    return {
        type: actionTypes.ASSIGN_SERIAL_NUMBER,
        payload: requestBody
    };
};

export const clearValidationState = () => {
    return {
        type: actionTypes.VALIDATE_SERIAL_NUMBER_CLEAR
    };
};
